const commentStyle = open => ({
  display: open ? 'block' : 'none'
})

export { commentStyle }
